import React from 'react';
import './Clients.css';

const Clients = () => {
    // Client logos array
    const clients = [
        { id: 12, name: 'Client 12', image: '/client12.avif' },
        { id: 13, name: 'Client 13', image: '/client13.avif' },
        { id: 1, name: 'Client 1', image: '/client1.avif' },
        { id: 2, name: 'Client 2', image: '/client2.avif' },
        { id: 3, name: 'Client 3', image: '/client3.avif' },
        { id: 4, name: 'Client 4', image: '/client4.avif' },
        { id: 5, name: 'Client 5', image: '/client5.avif' },
        { id: 6, name: 'Client 6', image: '/client6.avif' },
        { id: 7, name: 'Client 7', image: '/client7.avif' },
        { id: 8, name: 'Client 8', image: '/client8.avif' },
        { id: 11, name: 'Client 11', image: '/client11.avif' },
    ];

    
    // Create multiple copies for smooth infinite loop using looped indices
    const getLoopedClients = (copies = 4) => {
        const loopedClients = [];
        for (let i = 0; i < copies; i++) {
            clients.forEach((client, index) => {
                loopedClients.push({
                    ...client,
                    loopId: `${i}-${index}` // Using looped index
                });
            });
        }
        return loopedClients;
    };

    const loopedClients = getLoopedClients();

    return (
        <section className="clients-section" id="clients" data-aos="fade-up">
            <div className="clients-container">
                <div className="section-header">
                    <h2 data-text="Our Clients">Our Clients</h2>
                    <p>Trusted by leading businesses to drive digital transformation</p>
                </div>
                
                <div className="clients-carousel-wrapper">
                    <div className="clients-carousel">
                        {loopedClients.map((client) => (
                            <div key={client.loopId} className="client-logo-wrapper">
                                <img
                                    src={client.image}
                                    alt={client.name}
                                    className="client-logo"
                                    loading="lazy"
                                />
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Clients;
